import React from 'react'

import { styled } from '~/styled'

import { Text } from '../text/Text'
import { NavigationMenuLink } from './NavigationMenuLink'

export const NavigationMenuDropdownItem = React.forwardRef<
  HTMLAnchorElement,
  React.PropsWithChildren<React.ComponentProps<typeof NavigationMenuLink>>
>((props, forwardedRef) => {
  return (
    <NavigationMenuLink ref={forwardedRef} variant="dropdownItem" {...props} />
  )
})

export const NavigationMenuDropdownItemTitle = styled(Text, {
  base: ['text-grey-900', 'font-semibold']
})

NavigationMenuDropdownItem.displayName = 'NavigationMenuDropdownItem'
NavigationMenuDropdownItemTitle.displayName = 'NavigationMenuDropdownItemTitle'
